import { render, staticRenderFns } from "./LandingNew.vue?vue&type=template&id=28de282c&"
import script from "./LandingNew.vue?vue&type=script&lang=js&"
export * from "./LandingNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports